import React from "react";

import CateringConfigurationContent from "../components/catering/configuration-content.js";

const CateringConfiguration = () => {
  return <CateringConfigurationContent />;
};

export default CateringConfiguration;
